import React from 'react';

export default function MapControl({ children, position, ...props }) {
  return (
    <button
      type="button"
      name="Map Control"
      title="Map Control"
      aria-label="Map Control"
      className={`map-research-container ${position}`}
      {...props}
    >
      {children}
    </button>
  );
}
